import React, { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SectionWrapper from '../UI/SectionWrapper';

gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const textRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Parallax Image Effect
      // Parallax Image Effect REMOVED as per user request
      // Image remains static now.

      // Text Reveal on Scroll
      gsap.from(textRef.current.children, {
        y: 50,
        opacity: 0,
        duration: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: textRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <SectionWrapper ref={sectionRef} id="about" className="py-20 max-w-7xl mx-auto min-h-[80vh]">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl md:text-5xl font-serif text-forest-green mb-12 text-center">
          About Land Healing
        </h2>

        {/* Bento Grid */}
        <div ref={textRef} className="grid grid-cols-1 lg:grid-cols-5 gap-6 items-stretch">

          {/* Card 1: Intro & Main Text */}
          <div className="lg:col-span-3 bg-white/60 backdrop-blur-sm rounded-3xl p-8 lg:p-10 border border-white/40 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col justify-center">
            <p className="font-medium text-xl text-forest-green/90 mb-6 leading-relaxed">
             Land healing is a process of identifying and rebalancing underlying disturbances within a property. These disturbances may include man-made or natural geopathic stress, underground water or naturally occurring negative ley lines. When these influences are brought back into balance, the result is a calmer, more settled and supportive environment for living and working on.
            </p>
            {/* <p className="text-lg text-gray-700 font-sans leading-relaxed">
              By identifying imbalances and using these tools to rebalance them, negative influences can be cleared while positive features can be enhanced. This process raises the overall frequency of the land.
            </p> */}
            <div className="mt-8">
              <button
                onClick={() => document.getElementById('process')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-3 border border-forest-green text-forest-green hover:bg-forest-green hover:text-earthy-sand transition-all duration-300 rounded-full font-medium tracking-wide interactive"
              >
                Learn My Process
              </button>
            </div>
          </div>

          {/* Card 2: Logo Image */}
          <div className="lg:col-span-2 min-h-[400px] lg:min-h-full rounded-3xl overflow-hidden shadow-lg relative group bg-white/40 border border-white/40 backdrop-blur-sm flex items-center justify-center p-8">
            <div ref={imageRef} className="w-full h-full flex items-center justify-center transition-transform duration-700 group-hover:scale-105">
              <img
                src="/amelia-logo.png"
                alt="Amelia Land Healing Logo"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default About;
